var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tooltip',{attrs:{"text":"Cliquez pour ouvrir le menu d'action rapide"}},[_c('text-link',{on:{"click":_vm.openModal}},[_vm._v(" #"+_vm._s(_vm.subscriptionId)+" ")])],1),_c('quick-action-modal-base',{ref:"subscriptionModal",attrs:{"links":_vm.getQuickActionLinks,"title":_vm.getTitle,"limit-link-width":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }